module.exports = __webpack_public_path__ + "assets/img/mecha-btn-70127be1.png";